// removed by extract-text-webpack-plugin
module.exports = {"deliveries":"Deliveries__deliveries__quCCV","drivers":"Deliveries__drivers__2uns5","Deliveries":"Deliveries__Deliveries__1Yw13"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Deliveries/Deliveries.css
// module id = 233
// module chunks = 1